(function ($) {
    // Focusable pseoudo selector
    $.extend($.expr[':'], {
        focusable: function (el, index, selector) {
            var $el = $(el);
            return (
                $el.is('button, [href], input, select, textarea, object, [tabindex]:not([tabindex="-1"])') && // we don't need to check "area" tag, while it is focusable only when it has href attr
                $el.is(':not(:disabled)') && // disabled elements are not focusable
                $el.is(':visible')
            );
        },
    });
    // Tabbable pseudo selector
    $.extend($.expr[':'], {
        tabbable: function (el, index, selector) {
            var $el = $(el);
            return $el.is(':focusable') && $el.is(':not([tabindex="-1"])');
        },
    });
})(jQuery);
